import { clearInterval, setInterval } from 'worker-timers';

export default class Heartbeat {
  private readonly interval: number;

  private readonly timeout: number;

  private lastHeartbeat: number | undefined;

  private intervalId: number | undefined;

  constructor(interval = 5, timeout = 10) {
    this.interval = interval;
    this.timeout = timeout;
  }

  public updateHeartbeat(timestamp: bigint): void {
    console.debug('[Heartbeat] Heartbeat received from ', Number(timestamp));
    this.lastHeartbeat = Number(timestamp);
  }

  public stop(): void {
    if (this.intervalId != null) {
      console.debug('[Heartbeat]: Clearing existing interval');
      try {
        clearInterval(this.intervalId);
      } finally {
        this.intervalId = undefined;
      }
    }
  }

  // Define a onTimeout callback function
  public onTimeout: () => void;

  public start() {
    this.lastHeartbeat = Math.floor(Date.now() / 1000);
    this.stop();

    console.debug('[Heartbeat]: Starting heartbeat');
    this.intervalId = setInterval(() => {
      const currentTimestamp = Date.now() / 1000;
      console.debug('[Heartbeat]: Checking heartbeat, last ', this.lastHeartbeat);
      if (currentTimestamp - this.lastHeartbeat > this.timeout) {
        console.debug('[Heartbeat]: Heartbeat timeout, reconnecting');
        this.onTimeout();
      }
    }, this.interval * 1000);
  }
}
